import React from 'react';

/**
 * Default skeleton loader for role-protected content
 *
 * Displays a simple, reusable skeleton while the user's role is being verified.
 * This skeleton appears only in the content area, allowing the layout to render immediately.
 */
export const RoleProtectedSkeleton: React.FC = () => {
  return (
    <div className='p-8 space-y-6 animate-pulse'>
      {/* Header skeleton */}
      <div className='space-y-3'>
        <div className='h-8 bg-gray-200 rounded w-1/3'></div>
        <div className='h-4 bg-gray-200 rounded w-2/3'></div>
      </div>

      {/* Content skeleton */}
      <div className='space-y-4'>
        <div className='h-4 bg-gray-200 rounded w-full'></div>
        <div className='h-4 bg-gray-200 rounded w-5/6'></div>
        <div className='h-4 bg-gray-200 rounded w-4/6'></div>
      </div>

      {/* Card skeleton */}
      <div className='border border-gray-200 rounded-lg p-6 space-y-4'>
        <div className='h-6 bg-gray-200 rounded w-1/4'></div>
        <div className='space-y-2'>
          <div className='h-4 bg-gray-200 rounded w-full'></div>
          <div className='h-4 bg-gray-200 rounded w-3/4'></div>
        </div>
      </div>

      {/* Additional content skeleton */}
      <div className='grid grid-cols-2 gap-4'>
        <div className='h-24 bg-gray-200 rounded'></div>
        <div className='h-24 bg-gray-200 rounded'></div>
      </div>
    </div>
  );
};
